import React from 'react';

import TabsNavigation from 'components/basic/Button/TabsNavigation';

interface Props {
  side: string;
  handleChangeSide: (side: 'long' | 'short') => void;
}

export default function ConditionalTPSLSideTabs({
  side,
  handleChangeSide,
}: Props) {
  return (
    <TabsNavigation
      padding="0"
      buttons={[
        {
          title: 'Long',
          onClick: () => handleChangeSide('long'),
          active: side === 'long',
          stretch: true,
          underline: true,
          color: side === 'long' ? 'success' : undefined,
        },
        {
          title: 'Short',
          onClick: () => handleChangeSide('short'),
          active: side === 'short',
          stretch: true,
          underline: true,
          color: side === 'short' ? 'red' : undefined,
        },
      ]}
    />
  );
}
